import React from "react";
import styled from "styled-components";
import { CharacterResult } from "common/character/dto/CharacterResult";
import ModalLarge from "components/UI/modal/ModalLarge";
import CharacterEdit from "components/pages/character/Character/CharacterEdit";
import { NavMode } from "type/navigation/nav_mode.type";
import { NAV_MODE } from "constant/navigation";
import { Button } from "@mui/material";
import CharacterDescription from "components/common/character/CharacterDescription";

type CharacterModalLargeProps = {
  initMode?: NavMode;
  open: boolean;
  onClose?: (event: {}, reason: "backdropClick" | "escapeKeyDown") => void;
  title?: string;
  character: CharacterResult;
  onUpdate?: Function;
};

const CharacterModalLarge = ({
  initMode,
  open,
  onClose,
  title,
  character,
  onUpdate,
}: CharacterModalLargeProps) => {
  const [mode, setMode] = React.useState<NavMode>(initMode ?? NAV_MODE.DEFAULT);

  const toggleMode = () => {
    const newMode: NavMode =
      mode !== NAV_MODE.EDIT ? NAV_MODE.EDIT : NAV_MODE.DEFAULT;
    setMode(newMode);
  };

  return (
    <ModalLarge open={open} onClose={onClose} title={title}>
      Switch to:
      <Button onClick={toggleMode}>
        {mode !== NAV_MODE.EDIT ? "EDIT" : "DESCRIPTION"}
      </Button>
      {mode !== NAV_MODE.EDIT && <CharacterDescription character={character} />}
      {mode === NAV_MODE.EDIT && (
        <CharacterEdit character={character} onUpdate={onUpdate} />
      )}
      {/* <CharacterEdit character={character} onUpdate={onUpdate} /> */}
    </ModalLarge>
  );
};

export default CharacterModalLarge;
